import { render, staticRenderFns } from "./FormattedDescription.vue?vue&type=template&id=aa75c0f8"
import script from "./FormattedDescription.vue?vue&type=script&lang=ts"
export * from "./FormattedDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa75c0f8')) {
      api.createRecord('aa75c0f8', component.options)
    } else {
      api.reload('aa75c0f8', component.options)
    }
    module.hot.accept("./FormattedDescription.vue?vue&type=template&id=aa75c0f8", function () {
      api.rerender('aa75c0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FormattedDescription.vue"
export default component.exports